
import React from "react";
import "./Footer.css";
import logo from "../images/logo-intrading.jpeg";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Footer = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Inquiry Submitted Successfully!");
  };

  return (
    <footer className="footer">
      <div className="footer-top">

        {/* Logo & About */}
        <div className="footer-column company-info">
          <img src={logo} alt="Intrading Logo" className="footer-logo" />

          <p>
            InTrading is a trusted supplier of industrial and machinery
            solutions, delivering quality products and exceptional service
            across India.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-column">
          <h3>Quick Links</h3>

          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>

            <li>
              <Link to="/about">About</Link>
            </li>

            <li>
              <HashLink smooth to="/#machinery">
                Machinery
              </HashLink>
            </li>

            <li>
              <Link to="/certification">Certification</Link>
            </li>

            <li>
              <Link to="/international-fairs-media">
                International Fairs & Media
              </Link>
            </li>

            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        {/* Address */}
        <div className="footer-column">
          <h3>Showroom Address</h3>

          <p>IHDP Business Park</p>
          <p>Level 1, Plot No. 7</p>
          <p>Sector 127, Expressway</p>
          <p>Noida 201301</p>
          <p>Uttar Pradesh</p>

          <div className="footer-contact-details">
            <p>+91 7351847736</p>
            <p>+91 9810104567</p>
            <p>sr.merchandiser@inliving.com</p>
            <p>marketing@inliving.com</p>
          </div>
        </div>
         <div className="footer-column">
          <h3>Unit 1</h3>

          <p>InTrading Pvt Ltd</p>
          <p>Works at- 2Km Mile Stone,</p>
          <p>Ramgarh Road,</p>
          <p>P.O.Ratan Nagar,</p>
          <p>Churu,Rajasthan-331021,</p>
          <p>INDIA</p>

        
        </div>
         <div className="footer-column">
          <h3>Unit 2</h3>

          <p>Shrawan Handicraft</p>
          <p>143, Rithani Industrial Area</p>
          <p>Meerut, Uttar Pradesh,</p>
          <p> India</p>
      

         
        </div>

        {/* Contact Form */}
        {/* <div className="footer-column footer-form">
          <h3>Contact Us</h3>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Your Name"
              required
            />

            <input
              type="email"
              placeholder="Email Address"
              required
            />

            <textarea
              rows="4"
              placeholder="Your Message"
              required
            />

            <button type="submit">
              Send Inquiry
            </button>
          </form>
        </div> */}

      </div>

      <div className="footer-bottom">
        <p>© 2026 InTrading. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

